<template>
  <button
    class="bg-green-200 hover:bg-green-300 inline-flex justify-center p-2 md:p-1 md:pr-2 text-sm font-medium border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
  >
    <slot>Save Changes</slot>
  </button>
</template>
